import { __, _n } from '@wordpress/i18n';
import { IFreemius_Checkout_Option, IFreemius_Purchase_Response } from 'classes/interface.freemius-checkout';
import { IFreemius_Google_Ads_Settings, IGoogle_Ads_Conversion_Data } from './interface.freemius-google-ads'

/**
 * Implements the integration between Freemius Checkout and Google Ads.
 *
 * @since 0.8.8.220207
 * @link https://support.google.com/google-ads/answer/6095821?hl=en#gtm
 */
export class Freemius_Google_Ads {
	/**
	 * The settings passed to the class.
	 *
	 * @var IFreemius_Google_Ads_Settings
	 */
	protected settings: IFreemius_Google_Ads_Settings;

	/**
	 * Constructor.
	 *
	 * @param settings
	 */
	public constructor(settings: IFreemius_Google_Ads_Settings) {
		this.settings = settings;
	}

	/**
	 * Tracks a conversion using Google Tag Manager.
	 *
	 * @param freemius_response The response returned by Freemius.
	 * @param freemius_checkout_option The purchased option.
	 * @return void
	 * @link https://support.google.com/google-ads/answer/6095821?hl=en#gtm
	 */
	public track_conversion(freemius_response: IFreemius_Purchase_Response, freemius_checkout_option: IFreemius_Checkout_Option): void {
		// Safeguard. If the Google Tag script is not loaded, or the Google Ads tracking ID is empty, stop here
		if(!gtag || (this.settings.google_ads_conversion_id === '')) {
			return;
		}

		// Determine if the purchase is for a trial version
		const is_trial: boolean = ((freemius_response.purchase.trial_ends ?? false) !== false);

		let purchase_amount: number = 0;
		if(!is_trial) {
			purchase_amount = freemius_response.purchase.initial_amount ?? freemius_response.purchase.gross;
		}

		// @link https://support.google.com/google-ads/answer/6095821?hl=en#gtm
		const conversion_event_data: IGoogle_Ads_Conversion_Data = {
			send_to: this.settings.google_ads_conversion_id,
			transaction_id: freemius_response.purchase.id,
			value: purchase_amount,
			currency: freemius_response.purchase.currency.toUpperCase(),
		}

		// Send the conversion event to Google Ads
		gtag('event', 'conversion', conversion_event_data);
	}
}